var __assign = this && this.__assign || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function (resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator['throw'](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = this && this.__generator || function (thisArg, body) {
    var _ = {
            label: 0,
            sent: function () {
                if (t[0] & 1)
                    throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
    return g = {
        next: verb(0),
        'throw': verb(1),
        'return': verb(2)
    }, typeof Symbol === 'function' && (g[Symbol.iterator] = function () {
        return this;
    }), g;
    function verb(n) {
        return function (v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f)
            throw new TypeError('Generator is already executing.');
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y['return'] : op[0] ? y['throw'] || ((t = y['return']) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [
                        op[0] & 2,
                        t.value
                    ];
                switch (op[0]) {
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [0];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2])
                        _.ops.pop();
                    _.trys.pop();
                    continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useRef,
    useState
} from 'react';
import JustAskAidenIcon from '../../UI/sources/svg/just-ask-aiden.svg';
import AidenBubbleIcon from '../../UI/sources/svg/aiden-bubble.svg';
import {
    Modal,
    Popover,
    Typography
} from '@one/haven-design';
import { CloseFill } from '@one/haven-design-icons';
import $http, { Q } from '@http';
import {
    getCurrentEnv,
    isMobile,
    isTestingEnvironment,
    sendAmplitude_Default
} from '@common/utils';
import './copilotIndex.less';
import {
    AmplitudeEventName,
    EntryChannelSubType,
    LocalStorageKey,
    PostMessageType
} from '@common/enums/base';
import classNames from 'classnames';
import CopilotGuide from './copilotGuide';
import {
    CopilotAgent,
    CopilotAgentEntry
} from 'copilot-fixed-button';
import { getUrlParams } from '@common/utils/url';
import { inject } from 'mobx-react';
import { observer } from 'mobx-react-lite';
import { HeaderBusiness } from '@business/common/header';
var CopilotIndex = function (props) {
    var title = props.title, isPane = props.isPane, isBanner = props.isBanner, needFixedButton = props.needFixedButton, emergencyMessageHeight = props.emergencyMessageHeight;
    var _a = Modal.useModal(), modal = _a[0], contextHolder = _a[1];
    var ref = useRef();
    var _b = useState(false), visible = _b[0], setVisible = _b[1];
    var _c = useState(false), isPopoverOpen = _c[0], setPopoverOpen = _c[1];
    var _d = useState(false), isEnableCopilot = _d[0], setIsEnableCopilot = _d[1];
    var copilotMagicId = getUrlParams().copilotMagicId;
    var _e = useState({
            offset: [
                0,
                -10
            ]
        }), align = _e[0], setAlign = _e[1];
    useEffect(function () {
        var _a, _b;
        if (copilotMagicId && needFixedButton) {
            (_b = (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.handleOpen) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
        var getCopilotFixedButtonFeatureToggle = function () {
            return __awaiter(void 0, void 0, void 0, function () {
                var isEnableCopilot;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                    case 0:
                        return [
                            4,
                            Q($http.get('/Copilot/IsEnable'))
                        ];
                    case 1:
                        isEnableCopilot = _a.sent();
                        setIsEnableCopilot(isEnableCopilot);
                        return [2];
                    }
                });
            });
        };
        getCopilotFixedButtonFeatureToggle();
    }, []);
    useEffect(function () {
        var calcAlign = function () {
            var clientWidth = document.body.clientWidth;
            var width = Math.min(clientWidth - 32, 375);
            if (width < 375) {
                return {
                    offset: [
                        14,
                        -10
                    ]
                };
            }
            if (clientWidth < 375 + 64) {
                return {
                    offset: [
                        30 - (clientWidth - width) / 2,
                        -10
                    ]
                };
            }
            return {
                offset: [
                    0,
                    -10
                ]
            };
        };
        setAlign(calcAlign());
    }, []);
    var handleOpen = function () {
        var _a, _b;
        return (_b = (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.handleOpen) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    var getCredential = function () {
        return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                case 0:
                    return [
                        4,
                        Q($http.get('/copilot/getCreadential'))
                    ];
                case 1:
                    data = _a.sent();
                    return [
                        2,
                        data
                    ];
                }
            });
        });
    };
    var getEntry = function () {
        if (isBanner) {
            return React.createElement('div', {
                className: 'navbar-title text-white text-center r-0',
                style: { zIndex: 1000 }
            }, React.createElement('div', { className: 'copilot-title' }, React.createElement(Typography.Paragraph, { color: 'colorGray0White' }, 'Need to reschedule?'), React.createElement('div', {
                onClick: handleOpen,
                className: 'copilot-button'
            }, React.createElement('img', {
                style: {
                    width: '124px',
                    height: '23px'
                },
                src: JustAskAidenIcon
            }))));
        } else if (needFixedButton) {
            if (isEnableCopilot) {
                return React.createElement(CopilotAgent, {
                    visible: true,
                    entry: CopilotAgentEntry.RSP,
                    localStorageKey: LocalStorageKey.Copilot_FixedButton,
                    menuSelector: '.navbar',
                    showSideButton: true
                });
            }
        } else if (isPane) {
            return React.createElement('div', { className: 'copilot-title pt-2' }, React.createElement('div', {
                onClick: handleOpen,
                className: 'copilot-button',
                style: { fontFamily: 'Open Sans' }
            }, React.createElement('img', {
                style: {
                    width: '17px',
                    height: '17px'
                },
                src: AidenBubbleIcon
            }), 'Launch Aiden'));
        } else if (!title) {
            return React.createElement(React.Fragment, null, React.createElement('div', {
                className: 'navbar-title text-white text-center r-0',
                style: { zIndex: 1000 }
            }, React.createElement('div', { className: 'copilot-title' }, React.createElement(Typography.Paragraph, { color: 'colorGray0White' }, 'Need to reschedule?'), React.createElement(Popover, {
                overlayClassName: 'copilot-popover',
                tag: 'copilot',
                placement: 'bottom',
                okText: 'Done',
                showCancel: false,
                description: 'Get the help you need with our new chat experience, powered by Lessen AI.',
                open: isPopoverOpen,
                type: 'confirm',
                title: 'Chat with Aiden',
                icon: false,
                onConfirm: function () {
                    setPopoverOpen(false);
                }
            }, React.createElement('div', {
                onClick: handleOpen,
                className: 'copilot-button'
            }, React.createElement('img', {
                style: {
                    width: '124px',
                    height: '23px'
                },
                src: JustAskAidenIcon
            }))))), React.createElement(CopilotGuide, { setShowChatTooltip: setPopoverOpen }));
        }
    };
    return React.createElement(React.Fragment, null, contextHolder, getEntry(), React.createElement(CopilotIframe, {
        visible: visible,
        setVisible: setVisible,
        ref: ref,
        forwardTo: needFixedButton ? 'magicLink' : null,
        modalProps: emergencyMessageHeight ? {
            centered: false,
            style: {
                top: emergencyMessageHeight + 30,
                height: 'calc(100vh - ' + (emergencyMessageHeight + 30) + 'px)'
            }
        } : { style: { height: '85vh' } }
    }));
};
export var CopilotIframe = forwardRef(function (_a, ref) {
    var visible = _a.visible, setVisible = _a.setVisible, forwardTo = _a.forwardTo, postMessageData = _a.postMessageData, modalProps = _a.modalProps, sendMsg = _a.sendMsg;
    var _b = useState(), token = _b[0], setToken = _b[1];
    var iframeRef = useRef(null);
    useImperativeHandle(ref, function () {
        return { handleOpen: handleOpen };
    });
    useEffect(function () {
        var handleMessage = function (event) {
            var _a = (event === null || event === void 0 ? void 0 : event.data) || {}, type = _a.type, data = _a.data;
            if (type === PostMessageType.CloseCopilotWindow) {
                var needBackTraditional = data.needBackTraditional;
                if (!needBackTraditional) {
                    setVisible(false);
                    return;
                }
                setVisible(false);
                window.open(location.origin + '#/newRequest/create', '_self');
            }
        };
        visible && window.addEventListener('message', handleMessage, false);
        return function () {
            window.removeEventListener('message', handleMessage, false);
        };
    }, [visible]);
    var getCredential = function () {
        return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                case 0:
                    return [
                        4,
                        Q($http.get('/copilot/getCreadential'))
                    ];
                case 1:
                    data = _a.sent();
                    return [
                        2,
                        data
                    ];
                }
            });
        });
    };
    var handleOpen = function () {
        return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                case 0:
                    if (token) {
                        setVisible(true);
                        return [2];
                    }
                    return [
                        4,
                        getCredential()
                    ];
                case 1:
                    data = _a.sent();
                    setToken(data === null || data === void 0 ? void 0 : data.data);
                    setVisible(true);
                    sendAmplitude_Default(AmplitudeEventName.Copilot_Maintenance_Request, { env: getCurrentEnv() });
                    return [2];
                }
            });
        });
    };
    function joinCopilot() {
        function postJoined() {
            var iframeWindow = iframeRef.current.contentWindow;
            iframeWindow.postMessage({ type: PostMessageType.JoinedCopilot }, '*');
        }
        if (iframeRef.current) {
            postJoined();
        } else {
            setTimeout(function () {
                postJoined();
            }, 1000);
        }
    }
    useEffect(function () {
        var handleIframeLoad = function () {
            joinCopilot();
        };
        var iframe = iframeRef.current;
        if (iframe) {
            iframe.addEventListener('load', handleIframeLoad);
        }
        return function () {
            if (iframe) {
                iframe.removeEventListener('load', handleIframeLoad);
            }
        };
    }, [visible]);
    var onClose = function () {
        if (iframeRef.current) {
            var iframeWindow = iframeRef.current.contentWindow;
            iframeWindow.postMessage({
                type: PostMessageType.OpenLeaveModal,
                data: postMessageData
            }, '*');
        }
    };
    var copilotUrl = function () {
        var forwardToConfig = getForwardToConfig(sendMsg);
        var _a = forwardToConfig[forwardTo] || {}, _b = _a.path, path = _b === void 0 ? '' : _b, _c = _a.urlParams, urlParams = _c === void 0 ? '' : _c;
        return 'https://copilot' + getEnv() + '.lessen.com/' + path + '?token=' + token + urlParams;
    };
    return React.createElement(React.Fragment, null, visible && React.createElement(Modal, __assign({
        tag: 'Copilot_Modal',
        zIndex: 1040,
        centered: true,
        title: 'Aiden',
        maskClosable: true,
        open: visible,
        onCancel: onClose,
        className: classNames('copilot-modal', { radius: isMobile }),
        width: 800,
        footer: null
    }, modalProps), React.createElement('span', {
        onClick: onClose,
        className: 'copilot-cancel'
    }, React.createElement(CloseFill, null)), React.createElement('iframe', {
        id: 'copilot-iframe',
        ref: iframeRef,
        style: {
            width: '100%',
            height: '100%',
            border: 'none'
        },
        src: copilotUrl(),
        allow: 'camera; microphone'
    })));
});
var getEnv = function () {
    var env = getCurrentEnv();
    if (env === 'localhost') {
        return '-dev';
    }
    if (env === 'live' || isTestingEnvironment()) {
        return '';
    }
    return '-' + env;
};
var getMeshUrl = function () {
    var env = getCurrentEnv();
    if (isTestingEnvironment()) {
        env = 'live';
    }
    var meshUrl = {
        live: 'https://meshlive.lessen.com',
        stage: 'https://meshstage.lessen.com',
        dev: 'https://meshdev.lessen.com',
        localhost: 'https://meshdev.lessen.com',
        democenter: 'https://meshdc.lessen.com'
    };
    return meshUrl[env];
};
var getForwardToConfig = function (sendMsg, woNum) {
    return {
        create: {
            path: 'copilot/chat',
            urlParams: '&sendMsg=' + encodeURIComponent('I would like to create a new work order.') + '&urlParams=' + Buffer.from(JSON.stringify({ chat_entry_subsource: EntryChannelSubType.RSP_Request_Repair })).toString('base64')
        },
        magicLink: {
            path: 'copilot/magicLink',
            urlParams: '&id=' + getUrlParams().copilotMagicId
        }
    };
};
export default inject(HeaderBusiness)(observer(CopilotIndex));